import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import ContentBox from '../layout/ContentBox';
import UserEditDialogControls from './UserEditDialogControls';

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword: '',
      // eslint-disable-next-line react/no-unused-state
      nomatch: '',
      noSpaceAllowed: '',
    };
  }

  changePassword = (e) => {
    e.preventDefault();
    return this.props.onSubmit(this.state.oldPassword.trim(), this.state.newPassword.trim())
      .then(() => this.props.onClose())
      .catch(() => {
        this.setState({ error: <FormattedMessage id="changePassword.oldPasswordIncorrect" /> });
      });
  };

  validatePassword = () => {
    this.setState((state) => ({
      noSpaceAllowed: (/\s/.test(state.newPassword) ? <FormattedMessage id="registration.noSpaceCharacter" /> : ''),
    }));
  };

  confirmPassword = () => {
    this.setState({
      noMatch: this.state.newPassword !== this.state.newPasswordConfirm
      && <FormattedMessage id="resetPassword.passwordsDoNotMatch" />,
    });
  };

  render() {
    const { onClose } = this.props;
    return (
      <ContentBox title={<FormattedMessage id="account.changePasswordLabel" />}>
        <form onSubmit={this.changePassword}>
          <TextField
            sx={{ width: '100%' }}
            id="changePassword-oldPasswordTextField"
            type="password"
            label={<FormattedMessage id="changePassword.oldPasswordLabel" />}
            error={this.state.error}
            helperText={this.state.error}
            onChange={(e) => this.setState({ oldPassword: e.target.value })}
            variant="standard"
          />
          <TextField
            sx={{ width: '100%' }}
            id="changePassword-newPassword1TextField"
            type="password"
            label={<FormattedMessage id="changePassword.newPasswordLabel" />}
            error={this.state.noSpaceAllowed}
            helperText={this.state.noSpaceAllowed}
            onBlur={() => {
              this.validatePassword();
              this.confirmPassword();
            }}
            onChange={(e) => this.setState({ newPassword: e.target.value })}
            variant="standard"
          />
          <TextField
            sx={{ width: '100%' }}
            id="changePassword-newPassword2TextField"
            type="password"
            label={<FormattedMessage id="resetPassword.passwordConfirmLabel" />}
            error={this.state.noMatch}
            helperText={this.state.noMatch}
            onBlur={this.confirmPassword}
            onChange={(e) => {
              this.setState({ newPasswordConfirm: e.target.value }, this.confirmPassword);
            }}
            variant="standard"
          />
          <br />
          <br />
          <UserEditDialogControls
            onSave={async (e) => {
              await this.changePassword(e);
            }}
            onClose={onClose}
            disabled={
              !!this.state.noMatch
              || !this.state.newPassword
              || !this.state.oldPassword
              || !this.state.newPasswordConfirm
            }
          />
        </form>
      </ContentBox>
    );
  }
}

ChangePassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ChangePassword;
